/**
 * Safely format an API error detail for display in a toast.
 * FastAPI validation errors return detail as an array of objects,
 * which crashes toast.error() if passed directly.
 */
export const formatErrorDetail = (detail) => {
  if (!detail) return 'An error occurred';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (typeof d === 'string' ? d : d.msg || d.message || JSON.stringify(d)))
      .join(', ');
  }
  if (typeof detail === 'object') {
    return detail.msg || detail.message || JSON.stringify(detail);
  }
  return String(detail);
};
